import './TabPanel.css';
export var tabPanelCSS = '_1aufbgo0-2-0-1';
export var tabPanelOverflowBehaviorCSS = {hidden:'_1aufbgo1-2-0-1','scroll-y':'_1aufbgo2-2-0-1'};